import { useEffect, useState } from 'react';
import useScreenSize from './useScreenSize';
import { useWindow } from './useWindow';
export const useIsTouchDevice = () => {
    const [isTouch, setIsTouch] = useState(false);
    const myWindow = useWindow();
    const screenResize = useScreenSize();
    useEffect(() => {
        var _a;
        if (!!myWindow && !!screenResize) {
            setIsTouch(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test((_a = myWindow === null || myWindow === void 0 ? void 0 : myWindow.navigator) === null || _a === void 0 ? void 0 : _a.userAgent));
        }
    }, [myWindow, screenResize]);
    return isTouch;
};
